import { DeferredPromise } from './promise.js';
import { loadScript } from './script.js';

/** @type {?Promise} Store the singleton promise. */
let API_PROMISE = null;

/** @type {?READY_STATE_*} Store the promise status. */
let API_STATE = null;

/** @type {?string} Store the initial API URL. */
let API_URL = null;

const API_VERSION = '1.0.0';

const READY_STATE_LOADING     = 'loading';
const READY_STATE_INTERACTIVE = 'interactive';
const READY_STATE_ERRORED     = 'errored';

/**
 * Load Hitit API.
 *
 * @param  {?string} [url] - The base API URL.
 * @throws {TypeError} If attempting to use `new`.
 * @throws {TypeError} If `url` is invalid.
 * @throws {TypeError} If `url` is different from initial URL.
 * @return {Promise<READY_STATE_*>}
 */
export function whenApiIsReady(url) {
    if (this instanceof whenApiIsReady) {
        throw new TypeError(
            'whenApiIsReady is not a constructor'
        );
    }

    API_PROMISE ??= new DeferredPromise();

    if (url == null || API_URL === url) {
        return API_PROMISE;
    }

    if (API_URL != null) {
        throw new TypeError(
            `whenApiIsReady already has a URL: ${API_URL}`
        );
    }

    if (!URL.canParse(url)) {
        throw new TypeError(
            `whenApiIsReady expected a valid URL: ${url}`
        );
    }

    API_URL = url;

    API_PROMISE.execute(async (resolve, reject) => {
        if (API_STATE !== null) {
            return;
        }

        if (window.CraneSearchAPI) {
            API_STATE = READY_STATE_INTERACTIVE;
            resolve();
        }

        API_STATE = READY_STATE_LOADING;

        url = `${url}/js/hitit-ui/${API_VERSION}/searchapi.js`;

        try {
            await loadScript(url);

            if (window.CraneSearchAPI) {
                API_STATE = READY_STATE_INTERACTIVE;
                resolve();
            } else {
                API_STATE = READY_STATE_ERRORED;
                reject('Unavailable JS API: Expected CraneSearchAPI');
            }
        } catch (err) {
            API_STATE = READY_STATE_ERRORED;
            reject(err);
        }
    });

    return API_PROMISE;
}
